<template>
  <div class="bg-gray-100 mx-auto sm:px-6 lg:px-8 h-full">
    <div class="text-right">
      <img
        alt="Wildkogel - Die Arean"
        src="/wildkogel-logo-final.png"
        class="h-32 py-4 text-right"
      >
    </div>
    <Suspense>
      <template #default>
        <router-view />
      </template>
      <template #fallback>
        <div>Loading...</div>
      </template>
    </Suspense>
  </div>
</template>
